import React from 'react';
import PropTypes from 'prop-types';
import Label from '../Label';

const TextField = ({
    id,
    label,
    required,
    value = '',
    type = 'text',
    disabled = false,
    hideLabel = false,
    managed = false,
    onChange = null,
}) => {
    const defaultOrManagedValue = !managed ? { defaultValue: value } : { value, onChange };

    return (
        <div className="text">
            {!hideLabel && <Label id={id} text={label} required={required} />}
            <input
                id={id}
                aria-label={label}
                title={label}
                type={type}
                name={id}
                disabled={disabled}
                {...defaultOrManagedValue}
            />
        </div>
    );
};

TextField.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool.isRequired,
    value: PropTypes.string,
    type: PropTypes.string,
    disabled: PropTypes.bool,
    hideLabel: PropTypes.bool,
    managed: PropTypes.bool,
    onChange: PropTypes.func,
};

export default TextField;
